import React from 'react';
import PropTypes from 'prop-types';
import { capitalize, splitCamel } from '../../utils/format';
import './PropertySort.css';

const formatSortTypes = sortType => {
  let name;
  switch (sortType) {
    case 'sqft:high':
      name = sortType.replace(/(:)/g, ' ');
      capitalize(name);
      break;
    case 'sqft:low':
      name = sortType.replace(/(:)/g, ' ');
      capitalize(name);
      break;
    case 'acres:high':
      name = 'Acres:High';
      break;
    case 'acres:low':
      name = 'Acres:Low';
      break;
    case 'name:high':
      name = 'Name:Z-A';
      break;
    case 'name:low':
      name = 'Name:A-Z';
      break;
    case 'nearestAirport:low':
      name = 'Closest Airport';
      break;
    case 'nearestInterstate:low':
      name = 'Closest Interstate';
      break;
    default:
  }
  return name;
};

export function getParts(sortTypes) {
  const sortTypesDual = sortTypes.reduce((carry, type) => [...carry, `${type}:high`, `${type}:low`], []);
  return sortTypesDual
    .filter(type => {
      let approvedType;
      if (type !== 'nearestAirport:high' && type !== 'nearestInterstate:high') {
        approvedType = type;
      }
      return approvedType;
    })
    .map(type => {
      const name = splitCamel(formatSortTypes(type)).replace(/(:)/g, ' ');
      return [type, capitalize(name)];
    });
}

export const PropertySortComponent = ({ additionalSort, applied, handleSort, onSelected }) => {
  const sortTypes = [
    'name',
    'nearestAirport',
    'nearestInterstate',
  ];
  let formattedSortTypesList = getParts([additionalSort, ...sortTypes]);

  // Desctructured the formattedSortTypesList Array to reorder the Array
  // because name:low which sorts A-Z was below name:high which sorts Z-A
  const [acreshigh, acreslow, namehigh, namelow, closestAirportLow, closestInterstateLow]
  = formattedSortTypesList;
  formattedSortTypesList
  = [acreshigh, acreslow, namelow, namehigh, closestAirportLow, closestInterstateLow];
  return (
    <div className="sort-option-wrapper">
      {formattedSortTypesList.map(([type, name]) => {
        return (
          <div
            className="sort-option"
            key={type}
          >
            <a
              onClick={() => {
                handleSort(type.split(':'));
                onSelected();
              }}
              tabIndex="0"
            >
              {applied === name && <span />}
              {name.replace(/(- )/g, '-')}
            </a>
          </div>
        );
      })}
    </div>
  );
};

PropertySortComponent.propTypes = {
  additionalSort: PropTypes.string.isRequired,
  applied: PropTypes.string.isRequired,
  handleSort: PropTypes.func.isRequired,
  onSelected: PropTypes.func.isRequired,
};

export default PropertySortComponent;



// WEBPACK FOOTER //
// ./src/components/PropertySort/PropertySort.js